import { api } from 'app/config/apiConfig';
import { ContractItemPriceRaise, UpdateContractItemPriceRaiseDto } from '../model/types';

export const updateContractItemPriceRaiseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateContractItemPriceRaise: builder.mutation<
      ContractItemPriceRaise,
      UpdateContractItemPriceRaiseDto & { contractItemPriceRaiseId: string }
    >({
      query: ({ contractItemPriceRaiseId, ...body }) => ({
        url: `/contracts/price-raises/${contractItemPriceRaiseId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Contracts', 'Contract item price raises'],
    }),
  }),
});

export const { useUpdateContractItemPriceRaiseMutation } = updateContractItemPriceRaiseApi;
